import { grey, red } from "@mui/material/colors";

const styles = {
  mainContainer: {
    minHeight: "100%",
    backgroundColor: grey[100],
    padding: "24px",
  },
  addCategoryButton: {
    width: "130px",
    borderRadius: "0.5rem",
    height: "38px",
    color: "#FFFFFF",
    backgroundColor: red["A400"],
  },
};

export default styles;
